<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permission['requirements'] == 1">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-4">
            <div class="card shadow-sm">
              <div class="card-body">
                <form @submit.prevent="AddtoCart">
                  <span v-if="this.schoolrequirements.length <= 0">
                    <label
                      >Student :
                      <small class="text-primary">{{
                        student.student_id
                      }}</small></label
                    >
                    <multiselect
                      v-model="student"
                      :options="students"
                      placeholder="Select Student"
                      :custom-label="customLabel"
                    ></multiselect>
                    <label>Year</label>
                    <multiselect v-model="year" :options="years"></multiselect>
                    <label>Term</label>
                    <multiselect
                      v-model="schoolterm"
                      label="name"
                      @input="FilterFees()"
                      :options="schoolterms"
                    ></multiselect>
                  </span>
                  <div class="form-group mb-2">
                    <label>Requirement</label>
                    <multiselect
                      v-model="requirement"
                      label="name"
                      :options="requirements"
                      @input="updateQuantity"
                    ></multiselect>
                  </div>
                  <div class="form-group mb-2">
                    <label>Required Quantity</label>
                    <input
                      v-model="quantity"
                      readonly
                      style="background: none;"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group mb-3">
                    <label>Quantity Bought</label>
                    <input
                      v-model="quantitybought"
                      type="number"
                      required
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <button class="btn btn-primary w-100">
                      <i class="fas fa-check-circle"></i> Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="card shadow-sm">
              <span v-if="this.schoolrequirements.length <= 0">
                <div class="text-center p-5">
                  <span class="mdi mdi-cash text-success display-2"></span
                  ><br />
                  <span class="h4">No Item Selected</span>
                </div>
              </span>
              <span v-else>
                <div class="row p-3">
                  <div class="col-md-7">
                    <div class="h4">
                      {{ schoolrequirements[0].student.first_name }}
                      {{ schoolrequirements[0].student.last_name }} -
                      {{ schoolrequirements[0].schoolterm.name }} -
                      {{ schoolrequirements[0].year }}
                    </div>
                    <div class="table-responsive">
                      <b-table
                        :items="Items"
                        :fields="Fields"
                        responsive="sm"
                        :busy="IsBusy"
                      >
                        <template #table-busy
                          ><div class="text-center text-primary my-2">
                            <b-spinner
                              class="align-middle"
                              type="grow"
                              small
                            ></b-spinner>
                            <strong>No Data Found</strong>
                          </div></template
                        >
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(requirement)="data">
                          {{ data.item.requirement.name }}
                        </template>
                        <template #cell(actions)="data">
                          <b-button
                            @click="remove(data.item.id)"
                            type="button"
                            class="btn-sm btn"
                            variant="danger"
                            v-b-modal.delete
                          >
                            <i class="mdi mdi-trash-can"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group mb-2">
                      <!-- <b>Total</b>
                        <input v-model="cart_total" type="number" readonly class="form-control" /> -->
                    </div>
                    <br /><br /><br />

                    <div class="form-group">
                      <b>Register Date</b>
                      <input
                        v-model="paydate"
                        type="date"
                        required
                        class="form-control"
                      />
                    </div>
                    <div class="d-flex justify-content-between mt-3">
                      <div>
                        <b-button
                          class="btn btn-sm"
                          @click="SubmitExit"
                          variant="primary"
                          ><i class="mdi mdi-check-circle"></i> SUBMIT &
                          EXIT</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="delete-cart"
        centered
        title="Delete From Cart"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFromCart">
          <input v-model="id" type="hidden" />
          Are you sure you want to remove the record ?
          <!-- : <b>{{ requirement.name }}</b> -->
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-cart')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

import {
  feescartComputed,
  feescartMethods,
  feescategoryComputed,
  feescategoryMethods,
  paymentoptionComputed,
  paymentoptionMethods,
  requirementCategoryComputed,
  requirementCategoryMethods,
  requirementallocationComputed,
  requirementallocationMethods,
  schoolrequirementComputed,
  schoolrequirementMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "New Requirement Collection",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "New Requirement Collection",
      items: [
        { text: "Dashboard", href: "/" },
        { text: "New Requirement Collection", active: true },
      ],
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "requirement", label: "Requirement", visible: true },
        // { key: 'quantity', label: 'Required Quantity ', visible: true },
        { key: "quantitybought", label: "Quantity Brought", visible: true },
        { key: "actions", label: "Remove", visible: true },
      ],
      id: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      fees: "",
      requirement: "",
      student: "",
      student_id: "",
      amount: "",
      paydate: new Date().toLocaleDateString("fr-CA"),
      payoption: "",
      amountpaid: "0",
      quantitybought: "0",
      quantity: "",
      first_name: "",
      last_name: "",
      name: "",
      class: "",
      stream: "",
      allocations: [],
      requirements: [],
    };
  },
  methods: {
    ...feescategoryMethods,
    ...schooltermMethods,
    ...requirementCategoryMethods,
    ...studentMethods,
    ...schoolrequirementMethods,
    ...feescartMethods,
    ...requirementallocationMethods,
    ...paymentoptionMethods,
    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name}`;
    },
    async FilterFees() {
      let url = `/findrequirement/${this.schoolterm.id},${this.year},${this.student.class.id}`;
      //let url = `/findrequirement/${this.student.student.student_id},${this.requirement.id},${this.schoolterm.id},${this.year},${this.student.class.id}`;
      await axios.get(url).then((response) => {
        this.allocations = response.data.allocations;
        this.requirements = this.allocations.map(
          (allocation) => allocation.requirement,
        );
        this.quantity = "";
        this.requirement = "";
      });
    },
    updateQuantity() {
      if (this.requirement && this.allocations) {
        const allocation = this.allocations.find(
          (item) => item.requirement.id === this.requirement.id,
        );
        if (allocation) {
          this.quantity = allocation.quantity;
        } else {
          this.quantity = "";
        }
      }
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    remove(id, requirement) {
      this.id = id;
      this.requirement = requirement;
      this.$bvModal.show("delete-cart");
    },
    async AddtoCart() {
      let formData = new FormData();
      if (this.schoolrequirements.length <= 0) {
        formData.append("student", this.student.student.student_id);
        formData.append("term", this.schoolterm.id);
        formData.append("year", this.year);
      } else {
        formData.append("student", this.selectedStudent);
        formData.append("term", this.selectedTerm);
        formData.append("year", this.selectedYear);
      }
      formData.append("requirement", this.requirement.id);
      formData.append("quantity", this.quantity);
      formData.append("quantitybought", this.quantitybought);
      let url = "/addschoolrequirement";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.payoption = this.paymentoptions.find(
            (option) => option.set_default == 1,
          );
          this.fetchSchoolRequirement();
          this.student = "";
          this.schoolterm = "";
          this.requirement = "";
          this.quantity = "";
          this.quantitybought = "";
        }
      });
    },
    async removeFromCart() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deleteschoolrequirement";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolRequirement();
          this.$bvModal.hide("delete-cart");
        }
      });
    },
    async SubmitExit() {
      let obj = {
        cart: this.Cart,
        student: this.selectedStudent,
        term: this.selectedTerm,
        year: this.selectedYear,
        paydate: this.paydate,
      };
      let url = "/saveschoolrequirement";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolRequirement();
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
  computed: {
    ...feescategoryComputed,
    ...schooltermComputed,
    ...studentComputed,
    ...requirementallocationComputed,
    ...schoolrequirementComputed,
    ...feescartComputed,
    ...requirementCategoryComputed,
    ...paymentoptionComputed,
    cart_total() {
      var total = 0;
      this.schoolrequirements.forEach((item) => {
        var item_total = item.quantitybought;
        total = total + item_total;
      });
      return total;
    },
    List() {
      return this.schoolrequirements.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.schoolrequirements.map((d) => ({ ...d }));
    },
    Cart() {
      return this.schoolrequirements.map((d) => ({
        id: d.id,
        requirement: d.requirement.id,
        quantitybought: d.quantitybought,
        quantity: d.quantity,
      }));
    },
    IsBusy() {
      let a = false;
      if (this.schoolrequirements.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    selectedStudent() {
      let a = false;
      if (this.schoolrequirements.length > 0) {
        a = this.schoolrequirements[0].student.student_id;
      } else {
        a = "";
      }
      return a;
    },
    selectedTerm() {
      let a = false;
      if (this.schoolrequirements.length > 0) {
        a = this.schoolrequirements[0].schoolterm.id;
      } else {
        a = "";
      }
      return a;
    },
    selectedYear() {
      let a = false;
      if (this.schoolrequirements.length > 0) {
        a = this.schoolrequirements[0].year;
      } else {
        a = "";
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchFeesCategories();
    this.fetchSchoolRequirement();
    this.fetchRequirementAllocations();
    this.fetchStudents();
    this.fetchRequirementcategory();
    this.fetchSchoolTerms();
    this.fetchFeesCart();
    this.fetchPaymentoptions();
    this.isBusy = false;
    this.payoption = this.paymentoptions.find(
      (option) => option.set_default == 1,
    );
    this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
};
</script>
